<template>
  <v-toolbar
    v-if="!isEmbedded"
    :height="isEmbedded ? '35px' : '70px'"
    :max-height="isEmbedded ? '35px' : '70px'"
    color="white"
    fixed="true"
    class="px-0 Header">
    <a
      :href="`${externalLinks.siteHome}`"
      target="_blank"
      class="px-1">
      <!-- Gmelius Logo with Text -->
      <v-img
        :height="isEmbedded ? '24px' : '46px'"
        :width="isEmbedded ? '81px' : '155px'"
        src="/assets/logo/gmeliusLogo.png"
        class="mr-4"/>
    </a>

  </v-toolbar>

</template>
<script>
import { localeMixin } from '../mixins'
import { externalLinks } from '../config'

export default {
  mixins: [localeMixin],
  props: {
    isEmbedded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      externalLinks,
      loaded: false
    }
  }
}
</script>
<style lang="scss">
.Header {
  box-shadow:0 2px 1px -1px rgba(0, 0, 0, 0.033), 0 1px 1px 0 rgba(0, 0, 0, 0.033), 0 1px 3px 0 rgba(0, 0, 0, 0.033) !important;
  .v-toolbar {
    &__items {
      align-items: center;
    }
    &__title {
      font-size: 1rem;
      font-weight: 400;
      text-transform: none;
    }
  }
}
</style>
